import axios, { AxiosInstance } from 'axios';
import { getApiBaseUrl } from '../baseUrl';

// Criar instância do axios com configuração base
const axiosInstance: AxiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Interceptor de requisição para adicionar token
axiosInstance.interceptors.request.use(
  (config) => {
    // Tentar pegar token de diferentes fontes baseado no tipo de usuário
    let token = localStorage.getItem('authToken') ||
                localStorage.getItem('token') ||
                sessionStorage.getItem('candidatoToken') ||
                sessionStorage.getItem('token');

    // Adicionar token se existir (para todos os tipos de usuários)
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('❌ [Axios] Request error:', error);
    return Promise.reject(error);
  }
);

// Interceptor de resposta para tratar erros
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Verificar se o erro é relacionado a senha incorreta ou validação de dados
      // Nesses casos, NÃO devemos redirecionar para login
      const errorMessage = error.response?.data?.message || error.response?.data?.error || '';
      const isPasswordError = errorMessage.toLowerCase().includes('senha') ||
                              errorMessage.toLowerCase().includes('password');

      // Se for erro de senha/validação, apenas propagar o erro sem redirecionar
      if (isPasswordError) {
        return Promise.reject(error);
      }

      // Para outros erros 401 (token expirado/inválido), fazer logout e redirecionar
      // Limpar todos os possíveis tokens
      localStorage.removeItem('authToken');
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      sessionStorage.removeItem('candidatoToken');
      sessionStorage.removeItem('candidatoId');
      sessionStorage.removeItem('candidatoNome');
      sessionStorage.removeItem('userData');

      // Redirecionar baseado no caminho atual
      const currentPath = window.location.pathname;

      // Não redirecionar se já estiver em página de login ou cadastro
      if (!currentPath.includes('/login') && currentPath !== '/' && !currentPath.includes('/cadastrar')) {
        if (currentPath.includes('empresa') || currentPath.includes('dashboard-empresa')) {
          window.location.href = '/login-empresa';
        } else if (currentPath.includes('painel-vagas')) {
          window.location.href = '/login-candidato';
        } else {
          window.location.href = '/login-candidato';
        }
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;

// Função auxiliar para criar headers com token
export const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem('authToken') ||
                localStorage.getItem('token') ||
                sessionStorage.getItem('candidatoToken') ||
                sessionStorage.getItem('token');

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };

  // Adicionar token se existir
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
};

// Exportar também uma função para requisições sem interceptors (para login)
export const axiosPublic = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});